// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"YearsAxis_r-mobile__73HM_","r-not-mobile":"YearsAxis_r-not-mobile__ZVPb6","container":"YearsAxis_container__0aqis"};